import styled from 'styled-components';

export const PaymentMethods = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  border-bottom: 1px solid #000;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
`;
